<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      size="small"
      :height="tableHeight - 6"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <div class="m-2">
          <good-table
            :changeOrderCode="row.changeOrderCode"
            :code="row.orderPackingCode"
            :changeOrderPackingCode="row.changeOrderPackingCode"
            :packingType="row.packingType"
            :isUsed="row.isUsed"
            :expandDisabled="true"
            :disabled="disabled"
          />
        </div>
      </template>
      <template v-slot:showName="{ row }">
        <span>{{ row.materialName }} {{ row.materialDisplayName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: { code: row.changeOrderPackingCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled && !row.isUsed"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: { code: row.changeOrderPackingCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled && !row.isUsed"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del({ code: row.changeOrderPackingCode })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'copy',
                  params: { code: row.changeOrderPackingCode },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import GoodTable from '../edit-form/goods-table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  components: { GoodTable },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: Boolean,
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ code }) {
      this.$emit('submitDel', [code])
    },
    //批量删除前的验证
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      console.log(data)
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.changeOrderPackingCode
        })
      }
      return data
    },
  },
}
</script>
